/* src/app/private/components/clients/delete-client/delete-client.component.scss */
/*# sourceMappingURL=delete-client.component.css.map */
